import type { ReactNode } from 'react';
import cx from 'classnames';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
// @ts-expect-error - no types yet
import { TopNavigationBarItems } from 'src/views/TopNavigationBarItems';

import { useStyles } from './useStyles';

interface PageHeaderProps {
  className?: string;
  title?: string;
  largeTitle?: boolean;
  children?: ReactNode;
  titleComponentSlot?: ReactNode;
}

export const PageHeader = ({
  className,
  title,
  children,
  largeTitle,
  titleComponentSlot,
}: PageHeaderProps) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {titleComponentSlot ? (
        titleComponentSlot
      ) : (
        <CustomTypography
          className={styles.title}
          variant={largeTitle ? TYPOGRAPHY_VARIANT.h1 : TYPOGRAPHY_VARIANT.h2}
        >
          {title}
        </CustomTypography>
      )}

      <div className={styles.childrenWrapper}>{children}</div>

      <TopNavigationBarItems />
    </div>
  );
};
